import {EstateType} from "./models/api";
import {Dropdown, DropdownItem} from "../components";
import {DropdownGroup} from "xps-react";
import React from "react";
import {NO_OP} from "../constants/common";
import {useAnalyticsTrackers} from "../utils/useAnalyticsTrackers";
import {useAppSelector} from "../store/hooks";
import {selectReleaseToggles} from "../ReleaseToggles/releaseTogglesSlice";

export function WealthTransferOptions({estateType, onToggleEstateType}: {
    estateType: EstateType,
    onToggleEstateType: (estateType: EstateType) => void
}) {
    const { page } = useAnalyticsTrackers("enableGoogleAnalyticsWealthTransfer");
    const enable2026SunsetExemption = useAppSelector(selectReleaseToggles)?.enable2026SunsetExemption;

    const dropdownItemCurrentExemption = <DropdownItem itemText="" value="" onClick={NO_OP}>
        <div
            role={"option"}
            aria-selected={estateType !== EstateType.SUNSET}
            aria-label="Current Exemption"
            className="page-action-menu-options"
            onClick={(e) => {
                estateType !== EstateType.CURRENT && onToggleEstateType(EstateType.FUTURE);
                e.stopPropagation();
                page("WealthTransfer_CurrentExemption_Selected");
            }}
            onMouseOver={(e) => NO_OP}
            tabIndex={0}
        >
            Current Exemption
            <input name="estate-tax-exemption-group"
                   type="radio"
                   value="current-exemption"
                   checked={estateType !== EstateType.SUNSET}
                   onChange={(e) => {
                       estateType !== EstateType.CURRENT && onToggleEstateType(EstateType.FUTURE);
                   }}
            />
        </div>
    </DropdownItem>;

    const dropdownItem2026Exemption = <DropdownItem itemText="" value="" onClick={NO_OP}
                                                    disabled={estateType === EstateType.CURRENT}>
        <div
            aria-disabled={estateType === EstateType.CURRENT}
            role={"option"}
            aria-selected={estateType === EstateType.SUNSET}
            aria-label="2026 Sunset"
            className="page-action-menu-options"
            onClick={(e) => {
                if (estateType === EstateType.CURRENT) {
                    return;
                }
                onToggleEstateType(EstateType.SUNSET);
                e.stopPropagation();
                page("WealthTransfer_2026Sunset_Selected");
            }}
            onMouseOver={(e) => NO_OP}
            tabIndex={0}
        >
            2026 Sunset
            <input name="estate-tax-exemption-group"
                   type="radio" value="sunset"
                   checked={estateType === EstateType.SUNSET}
                   onChange={(e) => {
                       if (estateType === EstateType.CURRENT) {
                           return;
                       }
                       onToggleEstateType(EstateType.SUNSET);
                   }}
            />
        </div>
    </DropdownItem>;

    return <div className="wealth-transfer-options-dropdown">
        <Dropdown
            className="marginright-xs"
            dropdownKind={"menu"}
            rounded={true}
            buttonIcon={"only"}
            buttonSize={"medium"}
            buttonKind={"borderless"}
            iconNameOpen={"menu_dots"}
            iconNameClose={"menu_dots"}
            alignRight={true}
            panelHeight="auto"
            panelWidth={240}
            aria-label="more-options-dropdown"
        >
            <DropdownGroup groupName="Value">
                <DropdownItem itemText="" value="" onClick={NO_OP}>
                    <div
                        role={"option"}
                        aria-label={"Present Value"}
                        className="page-action-menu-options"
                        onClick={(e) => {
                            onToggleEstateType(EstateType.CURRENT);
                            e.stopPropagation();
                            page("WealthTransfer_PresentValue_Selected");
                        }}>
                        Present Value
                        <input name="value-group"
                               type="radio"
                               value="current"
                               checked={estateType === EstateType.CURRENT}
                               onChange={(e) => {
                                   onToggleEstateType(EstateType.CURRENT);

                               }}
                        />
                    </div>
                </DropdownItem>
                <DropdownItem aria-label={"future-value-option"} itemText="" value="" onClick={NO_OP}>
                    <div
                        role={"option"}
                        aria-label="Future Value"
                        className="page-action-menu-options"
                        onClick={(e) => {
                             estateType !== EstateType.SUNSET && onToggleEstateType(EstateType.FUTURE);
                             e.stopPropagation();
                            page("WealthTransfer_FutureValue_Selected");
                         }}>
                        Future Value
                        <input name="value-group" type="radio"
                               value="future"
                               checked={estateType !== EstateType.CURRENT}
                               onChange={(e) => {
                                   estateType !== EstateType.SUNSET && onToggleEstateType(EstateType.FUTURE);
                               }}/>
                    </div>
                </DropdownItem>
            </DropdownGroup>


            {enable2026SunsetExemption && <DropdownGroup groupName="Estate Tax Exemption"
                                                         label="Estate Tax Exemption Dropdown">
                {dropdownItemCurrentExemption}

                {dropdownItem2026Exemption}
            </DropdownGroup>}

            {!enable2026SunsetExemption && <DropdownGroup groupName="Estate Tax Exemption"
                                                          label="Estate Tax Exemption Dropdown">
                {dropdownItemCurrentExemption}
            </DropdownGroup>}
        </Dropdown>
    </div>;
}
